import React, { FunctionComponent, SVGProps } from "react";
import "./tableRow.scss";
import Tooltip from "@mui/material/Tooltip";
import ClickableSVG from "../../ClickableSVG/ClickableSVG";

interface TableRowProps<T extends object> {
  row: T;
  index: number;
  rowClick?: (index: number) => void;
  EndRowIcon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  DeleteRowIcon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  deleteClick?: (index: number) => void;
  showCheckbox?: boolean;
  isChecked?: boolean;
  onToggleCheckbox?: () => void;
}

const TableRow = <T extends object>({
  EndRowIcon,
  rowClick,
  row,
  index,
  showCheckbox = false,
  isChecked = false,
  onToggleCheckbox,
  DeleteRowIcon,
  deleteClick,
}: TableRowProps<T>) => {
  const keys = Object.keys(row);
  return (
    <div
      className="table-row-main-container"
      id={index % 2 === 0 ? "" : "table-row-gray-color"}
    >
      {showCheckbox && (
        <div className="cell checkbox-cell">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              e.stopPropagation();
              onToggleCheckbox && onToggleCheckbox();
            }}
          />
        </div>
      )}
      {/* <Form.Check inline /> */}
      {keys.map((key, index) => {
        const value = (row as any)[key];
        return (
          <div key={index + key.toLowerCase()} className="cell">
            {key.toLowerCase()?.includes("status") && (
              <div
                className={`indicator ${
                  value?.includes &&
                  ((Array.isArray(value) &&
                    value.some((val) => ["Active", "Enable"].includes(val))) ||
                    (typeof value === "string" &&
                      ["Active", "Enable"].includes(value)))
                    ? "green"
                    : "red"
                }`}
              ></div>
            )}
            <Tooltip
              title={
                typeof value === "string" || typeof value === "number"
                  ? String(value)
                  : ""
              }
            >
              <span
                className={`text ${
                  key.includes("Status") ? "rounded-status" : ""
                }`}
              >
                {React.isValidElement(value)
                  ? value
                  : typeof value === "function"
                  ? React.createElement(value)
                  : typeof value === "string" || typeof value === "number"
                  ? value
                  : "[Invalid content]"}
              </span>
            </Tooltip>
          </div>
        );
      })}

      {EndRowIcon && (
        <div className={`cell`}>
          {DeleteRowIcon && (
            <div className="cell">
              <ClickableSVG
                Icon={DeleteRowIcon}
                buttonAction={
                  deleteClick ? () => deleteClick(index) : undefined
                }
                disabled={!deleteClick}
              />
            </div>
          )}
          <EndRowIcon
            className="settings-icon"
            onClick={(e) => {
              e.stopPropagation();
              rowClick && rowClick(index);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default TableRow;
